import { render, staticRenderFns } from "./TreatmentPlanItem.vue?vue&type=template&id=3ff9fd42&scoped=true&lang=pug&"
import script from "./TreatmentPlanItem.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanItem.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanItem.vue?vue&type=style&index=0&id=3ff9fd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff9fd42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCard,VCol,VDivider,VIcon,VRow,VSkeletonLoader,VSpacer,VTextField,VTooltip})
